// index.js (Login component)
import React, { useState, useEffect } from "react";
import { LoginForm } from "./LoginForm";
import { SignupForm } from "./SignupForm";
import { PasswordResetFlow } from "./PasswordResetFlow";
import { useNavigate, useLocation } from 'react-router-dom';

export const Login = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [isVerification, setIsVerification] = useState(false);
  const [forgotPasswordMode, setForgotPasswordMode] = useState(false);
  
  // Registration states needed for verification
  const [regEmail, setRegEmail] = useState("");
  
  const navigate = useNavigate();
  const location = useLocation();

  // Check for signup parameter when component mounts
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.get('signup') === 'true') {
      setIsLogin(false);
    }
  }, [location]);

  const switchMode = () => {
    setIsLogin(!isLogin);
    setIsVerification(false);
  };

  const resetForm = () => {
    // This function can be passed to child components to reset all forms
    setIsLogin(true);
    setIsVerification(false);
    setForgotPasswordMode(false);
    setRegEmail("");
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="text-center text-3xl font-extrabold text-red-600 mb-8">
          {forgotPasswordMode 
            ? 'Reset Your Password' 
            : (isLogin ? 'Welcome Back' : (isVerification ? 'Verify Your Email' : 'Create Your Account'))}
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-lg rounded-lg sm:px-10 border border-gray-200">
          {forgotPasswordMode ? (
            <PasswordResetFlow 
              setForgotPasswordMode={setForgotPasswordMode} 
              resetForm={resetForm}
            />
          ) : isLogin ? (
            <LoginForm 
              setForgotPasswordMode={setForgotPasswordMode}
              navigate={navigate}
            />
          ) : (
            <SignupForm 
              isVerification={isVerification}
              setIsVerification={setIsVerification}
              regEmail={regEmail}
              setRegEmail={setRegEmail}
              setIsLogin={setIsLogin}
              resetForm={resetForm}
            />
          )}
          
          {!forgotPasswordMode && (
            <div className="mt-6">
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-300"></div>
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="px-2 bg-white text-gray-500">
                    {isLogin ? "Don't have an account?" : "Already have an account?"}
                  </span>
                </div>
              </div>

              <div className="mt-6">
                <button
                  type="button"
                  onClick={switchMode}
                  className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 
                            focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition duration-300"
                >
                  {isLogin ? 'Sign Up' : 'Back to Login'}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};